import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
  esp: (
    `
    <p>
      Jam antaŭlonge venis tempo por krei altnivelan spektaklon pri nia Esperanta vivo. 
      Kaj fin-fine ni kreis ĝin!
    </p>

    <p class="text-center mt-3 mb-3 bold">PERSONOJ KAJ PLENUMANTOJ</p>

    <p class="mb-1">
      1. Esperanton’ Bonov – la ĉefa pozitiva heroo. 
      Juna komputisto kun poŝkomputilo. 
      Tre bone rete instruas Esperanton.
    </p>
    <p class="mb-1">
      2. Aĉjo Malbonov – la eterna komencanto. 
      Iam li estis esperdona.
    </p>
    <p class="mb-1">
      3. Ina Amova – simpla esperantistino en top-bluzo. 
      Ŝi havas tre belan kaj kompleksan staturon… mi pardonpetas, komplikan naturon.
    </p>
    <p class="mb-1">
      4. Profesoro de Esperanto – tre sperta esperantisto.
    </p>

    <p class="text-center mt-3 mb-1 bold">UNUA AKTO</p>
    <p class="text-center mb-3">(Bonov kaj Ina, poste Malbonov)</p>

    <p class="mb-1">
      (Bonov kaj Ina kliniĝas super poŝkomputilo)
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Ina, ĉu vi kredas, ke ni kreos novan Mikrosoft aŭ Linuks ?
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Ne. Ni elpensos novan serĉsistemon kaj nomos ĝin RET-INO!
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Ina, ĉu vi sentas la krean entuziasmon?
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Aha…
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Ĉu vi scias, Ina, iam mi pensis, ke vi estas simpla stultulino…
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Ĉu tio ĉi malhelpas al tiuj, kiuj amas … Esperanton?
    </p>

    <p class="mb-1">
      <span class="bold">(Bonov kaj Ina ĥore)</span>: Tuj ni ion eltrovos!
    </p>
    
    <p class="mb-1">
      <span class="bold">Malbonov</span>: Neniam! Tuj mi faros malhonorindan agon!
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Ne, vi ne faros tion. 
      Ja en la profundo de via animo brilas la flamo de espero! 
      Estas bezonate nur kompreni vin!
    </p>

    <p class="mb-1">
      <span class="bold">Malbonov</span>: Vere! 
      Mi ĉesu lernadon de Esperanto. 
      Anstataŭ tio mi vizitos suspektindajn lokojn; mi drinkos tie, uzos drogaĉojn kaj malsaniĝos je aidoso. 
      Tiam ĉiuj ekamos kaj kompatos min.
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Kaj mi en la sama tempo okupiĝos pri Esperanto, sentante por tio naturan bezonon!
    </p>

    <p class="text-center mt-3 mb-1 bold">DUA AKTO</p>
    <p class="text-center mb-3">(Profesoro, poste Bonov, Ina, Malbonov)</p>

    <p class="mb-1">
      <span class="bold">Profesoro</span>: Mia profesio estas profesoro. 
      Aŭ esperantisto. 
      Aŭ ano de UEA, aŭ ao de UNEA, - mi jam ne memoras. 
      En infaneco mi ŝatis Esperanton. 
      Aŭ infanojn… Aŭ ne ŝatis… 
      Kaj nun mi estas maljuna kaj emas spertinterŝanĝi kun junaj esperantistoj. 
      Mi ŝatas paroli pri Esperanto. Kaj ĝenerale mi ŝatas paroli… 
      Ho, Esperanto! Vi estas plena de enigmoj! 
      Skizofrenio! Skorzonero! Skovelo! Skolopo! Kiaj vortoj!
      <br/>
      Ha, Bonov! Denove vi alvenis kun viaj frenezaj ideoj?
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Mi estas certa, ke vi, profesoro, komprenos min.
    </p>

    <p class="mb-1">
      <span class="bold">Profesoro</span>: Ĉu kompreni? 
      Ja vi denove neniigis la teorion de instruado. 
      Mi ne permesos al vi pereigi la fundamentan verkon de la tuta mia vivo!
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Profesoro, dank’ al vi ni fariĝos oferoj de scienco.
    </p>

    <p class="mb-1">
      <span class="bold">Profesoro</span>: Iĝu! 
      Kaj mi ripozos sur miaj laŭroj kaj kripligos la animojn de junaj esperantistoj. 
      Mi estas obskuranto!
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Ina, ni perdu la esperon kaj foriru de ĉi tie. Edziniĝu al mi!
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Ne, Esperanton’. 
      Mi edziniĝos al Malbonov. 
      Ja mi estas tiel komplika naturo, kaj li tia komencanto… 
      Mi devas helpi lin.
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Sed vi suferos!
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Jes. En la flamo de sufero mia amo hardiĝos kaj fariĝos eĉ pli pura!
    </p>

    <p class="mb-1">
      <span class="bold">Malbonov</span>: Sed mi perfidos vin.
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Iru! Forlasu min por alia esperantistino!
    </p>

    <p class="mb-1">
      <span class="bold">Malbonov</span>: Ne tuj. Poste. Kiam vi havos bebon. Aŭ eĉ du…
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Mi devas vangofrapi vin.
    </p>

    <p class="mb-1">
      <span class="bold">Malbonov</span>: Vi ne povas tion fari, ĉar vi havas tre altajn moralajn kvalitojn.
    </p>

    <p class="mb-1">
      <span class="bold">Bonov</span>: Ĉiuokaze por vi ne estas loko en Esperanto!
    </p>

    <p class="mb-1">
      <span class="bold">Profesoro</span>: Ho, Esperanto. 
      Vi, junaj, ne komprenas ĝin. 
      Vi verkas en Esperanto iujn neseriozajn kantaĉojn kaj teatraĵetojn anstataŭ aŭskulti miajn seriozajn tralegojn kaj prelegojn. 
      Vi noktumas apud lignofajro kaj provludas tage, anstataŭ partopreni en someraj universitatoj.
      <br/>
      Vi ne obeas min, kvankam mi estas profunda pensiulo… pensulo… tamen tre distriĝema. 
      Jen, denove mi perdis mian aŭtoritaton… Kie ĝin trovi?
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Ho, kiel li suferas! Mi tuj edziniĝos al li! 
      Mi estos profunde malfeliĉa edzino de spertulo. Aŭ de pensiulo… Aŭ de penisulo…
    </p>

    <p class="mb-1">
      <span class="bold">Malbonov</span>: Ina, edziniĝu prefere al mi. Pro la lasta kondiĉo.
    </p>

    <p class="mb-1">
      <span class="bold">Ina</span>: Mi ne povas. Ĉar mi estas tiel komplika laŭ mia naturo.
    </p>
    
    <p class="mb-1">
      (kantas)
    </p>
    
    <p class="mb-1">
      <span class="bold">Bonov</span>: Ina, mi estas feliĉa! Mi amas vin!
    </p>

    <p class="mb-1">
    (kantas)
    </p>

    <p class="mb-1">
      <span class="bold">Malbonov</span>: Ho, kiel mi morale pereis!
    </p>

    <p class="mb-1">
      (pereas)
    </p>

    <p class="text-center mt-3 mb-3 bold">KURTENO</p>
    `
  )
}

const itemName = {
  esp: 'Ama kvadrato'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
    itemDate: '1984-2004.'
  }
}

export default item;